import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import parseJson from 'utils/parsers/parseJson';
import isMissing from 'utils/predicates/any/isMissing.util';

const L = logger('FLAG-UTIL'); // eslint-disable-line no-unused-vars

// NOTE: should return a boolean
export const flagB = (deFault, value) => {
  if (true === value || false === value) return value;

  if (value !== '' && value !== void 1 && value !== null) return value !== 'no' && value !== 'false';

  if (deFault !== true && deFault !== false) L.warn('flagB()', 'Bad deFault:', deFault);

  return deFault;
};

// NOTE: should return an integer
export const flagI = (deFault, value) => {
  const parsed = fromAnyToInteger(value);

  if (Number.isSafeInteger(parsed)) return parsed;

  if (!Number.isSafeInteger(deFault)) L.warn('flagI()', 'Bad deFault:', deFault);

  return deFault;
};

// NOTE: should return a floating point number
export const flagF = (deFault, value) => {
  const parsed = fromAnyToNumber(value);

  if (Number.isFinite(parsed)) return parsed;

  if (!Number.isFinite(deFault)) L.warn('flagF()', 'Bad deFault:', deFault);

  return deFault;
};

// NOTE: should return a string
export const flagS = (deFault, value) => {
  const string = fromAnyToString(value).trim();

  if (string) return string;

  if (String(deFault) !== deFault) L.warn('flagS()', 'Bad deFault:', deFault);

  return deFault;
};

// NOTE: should return an object
export const flagJ = (deFault, value) => {
  const json = fromAnyToString(value);

  // check in order to avoid parseJson printing a warning that the JSON is invalid
  const parsed = json ? parseJson(json) : void 1;

  if (!isMissing(parsed)) return parsed;

  if (isMissing(deFault)) L.warn('flagJ()', 'Bad deFault:', deFault);

  return deFault;
};
